import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  Grid,
  RadioGroup,
  FormControl,
  FormGroup,
  MenuItem,
  IconButton,
  Button,
} from "@mui/material";
import { Delete, Add } from "@mui/icons-material";
import React from "react";

const Comp11PDF = ({
    formData,
    checked
}) => {

    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

  return (
    <Container sx={{ mt: 5, borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box>
        <Typography variant="h6">しんきんビジネスフェア出展者　マイページ情報</Typography>
        {formData ? (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
            <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
            <Typography variant="body1">部署: {formData?.department}</Typography>
            <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
            <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
            <Typography variant="body1">住所: {formData?.address}</Typography>
            <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
            <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
        </Box>
        ) : (
        <Typography variant="body2">読み込み中...</Typography>
        )}
    </Box>
    <Box>
        <Typography variant="h6">防炎対象物品申込、危険物品（石油・ガス・裸火等）の許可申込</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>氏名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_11_name}</Box>
                <Box>部署</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_11_department}</Box>
                <Box>会社電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_11_phone}</Box>
                <Box>携帯電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_11_tel}</Box>
            </Box>
            <Box>
            <Typography variant="h6" gutterBottom>危険物品</Typography>
            <Typography variant="subtitle2" gutterBottom>アルコール類</Typography>
            {formData?.alchol_details.map((item, index) => (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                    <Typography>品名 ： {item.alchol_name}</Typography>
                    <Typography>量(L) ： {item.alchol_quantity}</Typography>
                </Box>
            ))}

            <Typography variant="subtitle2" gutterBottom>石油類</Typography>
            {formData?.oil_details.map((item, index) => (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                    <Typography>カテゴリ ： {item.oil_category}</Typography>
                    <Typography>品名 ： {item.oil_name}</Typography>
                    <Typography>量(L) ： {item.oil_quantity}</Typography>
                </Box>
            ))}

            <Typography variant="subtitle2" gutterBottom>ガス類</Typography>
            {formData?.gas_details.map((item, index) => (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                    <Typography>カテゴリ ： {item.gas_category}</Typography>
                    <Typography>ガス名 ： {item.gas_name}</Typography>
                    <Typography>量(L/1本) ： {item.gas_quantity}</Typography>
                    <Typography>ボンベ(本) ： {item.gas_number}</Typography>
                    <Typography>合計 ： {item.gas_total || 0}リットル</Typography>
                </Box>
            ))}

            <Typography variant="subtitle2" gutterBottom>裸火</Typography>
            {formData?.fire_details.map((item, index) => (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                    <Typography>機器名 ： {item.fire_device_name}</Typography>
                    <Typography>使用方法 ： {item.fire_using}</Typography>
                    <Typography>消費熱量(J) ： {item.fire_amount}</Typography>
                </Box>
            ))}
            </Box>
            <Typography variant="h6">備考欄</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {formData?.alfa_text}
                        </Typography>
        </Box>
        )}
    </Box>
    </Container>
  );
};

export default Comp11PDF;
